module.exports = __webpack_public_path__ + "static/sample-4-a57d4f50cc687b0394d2455e0c79ded1.png";